import { render } from "./AdmTop.vue?vue&type=template&id=1f097153&scoped=true"
import script from "./AdmTop.vue?vue&type=script&lang=js"
export * from "./AdmTop.vue?vue&type=script&lang=js"

import "./AdmTop.vue?vue&type=style&index=0&id=1f097153&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f097153"]])

export default __exports__